var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.style)?_c('div',{ref:"lavContainer",style:(_vm.style)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }